/**
 *
 */
const setupNewsStoryGalleries = () =>
{
	const stories = document.querySelectorAll( '.section-news-story-gallery .gallery .news-story' );

	stories.forEach( story =>
	{
		const link = story.querySelector( '.read-more a' );

		if (!(link instanceof HTMLAnchorElement)) {
			return;
		}

		story.addEventListener( 'click', () =>
		{
			link.click();
		} );
	} );
};


export default setupNewsStoryGalleries;